export default __webpack_public_path__ + "static/media/logo_azagros_branca.567d8eaf.png";